import React from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '../common/Focusable';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import PaginationCore from './PaginationCore';
import { st, classes } from './Pagination.st.css.js';
const coreComponentDefaults = {
    showFirstPage: true,
    showLastPage: true,
    responsive: false,
    showFirstLastNavButtons: false,
    showInputModeTotalPages: false,
    paginationMode: 'pages',
    nextLabel: React.createElement(ChevronRight, { className: classes.arrow }),
    previousLabel: React.createElement(ChevronLeft, { className: classes.arrow }),
};
/** Component for pagination */
class Pagination extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._getMaxPagesToShow = () => {
            const { currentPage, totalPages } = this.props;
            const absoluteNumDistance = Math.min(Math.abs(1 - currentPage), Math.abs(currentPage - totalPages));
            if (absoluteNumDistance >= 4) {
                return 9;
            }
            else if (absoluteNumDistance === 3) {
                return 8;
            }
            return 7;
        };
    }
    render() {
        const { dataHook, currentPage, totalPages, onChange, nextLabel, previousLabel, className, pageUrl, } = this.props;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": dataHook, onFocus: this.props.focusableOnFocus, onBlur: this.props.focusableOnBlur },
            React.createElement(PaginationCore, Object.assign({ className: classes.pagination }, coreComponentDefaults, { previousLabel: previousLabel || coreComponentDefaults.previousLabel, nextLabel: nextLabel || coreComponentDefaults.nextLabel, onChange: onChange, totalPages: totalPages, currentPage: currentPage, maxPagesToShow: this._getMaxPagesToShow(), showNextLabel: currentPage !== totalPages, showPreviousLabel: currentPage !== 1, pageUrl: pageUrl }))));
    }
}
Pagination.displayName = 'Pagination';
Pagination.propTypes = {
    /** Applies a data-hook HTML attribute that can be used in the tests */
    dataHook: PropTypes.string,
    /** Specifies a CSS class to be applied to the component’s root element */
    className: PropTypes.string,
    /** Sets a number of available pages to show in the component */
    totalPages: PropTypes.number,
    /** Specifies a currently selected page */
    currentPage: PropTypes.number,
    /** Defines a callback function which returns a selected page or an arrow ({`event`,`page`}) */
    onChange: PropTypes.func,
    /** Get pageNumber and returns url */
    pageUrl: PropTypes.func,
};
Pagination.defaultProps = {
    currentPage: 1,
};
export default withFocusable(Pagination);
//# sourceMappingURL=Pagination.js.map